var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.idName}})
}
var staticRenderFns = []

export { render, staticRenderFns }